import { EventBus } from '../services/event-bus.js';
import { EVENTS } from '../store/nameConstants';

export default {
    data() {
        return {
            isReset: new Date()
        };
    },

    created() {
        EventBus.$on(EVENTS.RESET, () => {
            this.isReset = new Date();
        });
    },

    computed: {
        reset() {
            return this.isReset;
        }
    }
};
